import React, { useContext, useState, useEffect, useMemo } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';
import { DynamicModalContext } from '../../../init/dynamicModals';

import { Col, Form, Row, InputGroup } from 'react-bootstrap';
import { Space, Input, Dropdown, Button, Spin, Tabs } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaPlus } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const InvoiceCart = (props) => {

    const { cart, setCart, journalVoucher, cartItem } = props;

    const { api, userData, settingData, accountData, rateFromToCurrency,
        defaultCurrency, productOptions, loadProductOptions } = useContext(DataContext);

    const { openAddProductModal } = useContext(DynamicModalContext);

    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const { showModal, toggleModal, table, title, refreshTable, size, footer, idRow, type } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [spinning, setSpinning] = React.useState(false);
    const [scannedBarcode, setScannedBarcode] = useState("");


    // Add new row
    const handleAddRow = () => {
        setCart((prevCart) => [...prevCart, cartItem]);
    };

    // Delete VarientRow
    const handleDeleteRow = (event, type) => {
        event.preventDefault()

        if (cart.length > 1) {
            const updatedRows = cart.slice(0, -1);
            setCart(updatedRows);
        } else {
            toast.error('you need at least one item')
        }


    };

    // handle row changes
    const handleRowChange = (index, value, field) => {
        const updatedCart = [...cart];

        if (field == 'product') {
            updatedCart[index].productId = value.id;
            updatedCart[index].cost = rateFromToCurrency(value.currency, defaultCurrency, value.cost);
            updatedCart[index].units = value.units;
            updatedCart[index].unitQuantity = 1;
            updatedCart[index].quantity = 1;
            updatedCart[index].index = index;
            updatedCart[index].type = value.type;
            updatedCart[index].vatPercentage = value.vat;
            updatedCart[index].isStock = value.isStock;
            updatedCart[index].stocks = value.stocks;

            if (value.type == 'simple' || value.type == 'serialized') {
                updatedCart[index].accountId = settingData.stockOfGoodsForSaleAccountId;
            }
            else if (value.type == 'rawMaterial') {
                updatedCart[index].accountId = settingData.stockOfRawMaterialsAccountId;
            }
            else if (value.type == 'production') {
                updatedCart[index].accountId = settingData.stockOfManufacturedProductsAccountId;
            }

        }
        else if (field == 'unitQuantity') {
            updatedCart[index].unitQuantity = value.quantity;
            updatedCart[index].unitName = value.name;

        }
        else if (field == 'quantity') {
            updatedCart[index].quantity = value;

        }
        else if (field == 'subQuantity') {
            updatedCart[index].subQuantity = value;

        }
        else if (field == 'details') {
            updatedCart[index].details = value;

        }

        updatedCart[index].netQuantity = parseFloat(updatedCart[index].subQuantity);

        updatedCart[index].priceDiscountAmount = (updatedCart[index].priceDiscountPercentage / 100) * (updatedCart[index].price * updatedCart[index].subQuantity);

        // TOTAL price
        updatedCart[index].netCost = updatedCart[index].cost;
        updatedCart[index].totalCost = (updatedCart[index].cost * updatedCart[index].subQuantity);

        setCart(updatedCart);
    }


    const handleBarcodeScan = (e) => {
        const barcode = e.target?.value;
        const product = productOptions?.find(option => option.barcode === barcode);

        if (!product) {
            toast.error('Product not found');
            setScannedBarcode('');
            return;
        }

        setCart((prevCart) => {
            let updatedCart = [...prevCart];
            const existingProductIndex = updatedCart.findIndex(option => option.productId === product.id);

            if (existingProductIndex > -1) {
                let subQuantity = parseFloat(updatedCart[existingProductIndex].subQuantity) + parseFloat(1);
                handleRowChange(existingProductIndex, subQuantity, 'subQuantity');
            } else {
                // Add new product row
                const productItem = {
                    accountId: settingData.stockOfGoodsForSaleAccountId,
                    productId: product.id,
                    price: parseFloat(product.price),
                    units: product.units,
                    unitQuantity: 1,
                    subQuantity: 1,
                    priceDiscountAmount: 0,
                    priceDiscountPercentage: 0,
                    netQuantity: 1,
                    unitName: '',
                    netPrice: product.price,
                    type: product.type,
                    isStock: product.isStock,
                    cost: product.cost,
                    netCost: product.cost,
                    totalCost: product.cost,
                    stocks: product.stocks,
                    netQuantity: 1,
                    quantity: 1,
                    vatPercentage: product.vat,
                };

                if (cart.length == 1 && !cart[0].productId) {
                    updatedCart = [productItem];
                } else {
                    updatedCart.push(productItem);
                }

            }

            return updatedCart;
        });

        setScannedBarcode('');
    };


    const items = useMemo(() =>
        [
            {
                label: 'Simple',
                key: '1',
                onClick: () => openAddProductModal('simple')
            },
            {
                label: 'Serialized',
                key: '2',
                onClick: () => openAddProductModal('serialized')
            }
        ]);


    const handleDeleteRowIndex = (index) => {
        const updatedRows = cart.filter((_, i) => i !== index);
        setCart(updatedRows);
    };


    return (

        <div>
            <Spin spinning={spinning} fullscreen />
            <Row >

                <Col md={4}>
                    <Form.Label style={{ display: "inline-block", marginRight: "10px" }}>
                        Select Products
                    </Form.Label>
                    <Dropdown menu={{ items }} trigger={['click']} overlayStyle={{ zIndex: 9999 }} transitionName="">
                        <a onClick={e => e.preventDefault()}>
                            <Space> <FaPlus style={{ marginTop: "-8px" }} size={15} /> </Space>
                        </a>
                    </Dropdown>
                </Col>


                <Col>
                    <Form.Label>Unit</Form.Label>
                </Col>
                <Col>
                    <Form.Label>Quantity</Form.Label>
                </Col>
                <Col>
                    <Form.Label>net Quantity</Form.Label>
                </Col>
                <Col>
                    <Form.Label>Warehouse</Form.Label>
                </Col>
                <Col>
                    <Form.Label>Variation</Form.Label>
                </Col>
                <Col>
                    <Form.Label>Details</Form.Label>
                </Col>
                <Col style={{ flex: 0.2 }}>
                </Col>

            </Row>



            {cart.map((row, index) => (


                <Row className="g-0 mb-1" key={index}>
                    <Col md={4}>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={loadProductOptions}
                            defaultOptions={[]}
                            onChange={(e) => handleRowChange(index, e, 'product')}
                            value={productOptions?.find(option => option.value === cart[index].productId) || []}
                            noOptionsMessage={() => 'type to view'}
                            required
                        />
                    </Col>

                    {/* Units  Quantity*/}
                    <Col>
                        <Select
                            options={[
                                {
                                    value: { name: "", quantity: 1 },
                                    label: `(x1)`
                                },
                                ...(cart[index]?.units?.map(unit => ({
                                    value: { name: unit.name, quantity: unit.quantity },
                                    label: `${unit.name} (x${unit.quantity})`
                                })) || [])
                            ]}
                            onChange={(e) => handleRowChange(index, e.value, 'unitQuantity')}
                            defaultValue={{
                                value: JSON.stringify({ name: cart[index]?.unitName, quantity: cart[index]?.unitQuantity }),
                                label: `${cart[index]?.unitName} (x${cart[index]?.unitQuantity || 1})`
                            }}
                            className="react-select-sm"
                        />

                    </Col>

                    {/*  Quantity  */}
                    <Col>
                        <Form.Control type="number" min={0} step='any'
                            onChange={(e) => handleRowChange(index, e.target.value, 'subQuantity')}
                            style={{ backgroundColor: '#f0f8ff' }}
                            value={cart[index].subQuantity}
                            required
                        />
                    </Col>

                    {/* netQuantity */}
                    <Col>
                        <Form.Control type="number" min={0} step='any' value={cart[index].netQuantity * cart[index].unitQuantity}
                            style={{ backgroundColor: '#f7e8e8' }}
                            disabled
                        />
                    </Col>

                    {/* warehouse */}
                    <Col>
                        <Form.Control type="number" min={0} step='any'
                            value={cart[index]?.stocks?.find(s => (s.productId === cart[index].productId) && (s.warehouseId == journalVoucher?.warehouseId))?.stock ?? 0}
                            style={{ backgroundColor: '#f7e8e8' }}
                            disabled
                        />
                    </Col>

                    {/* variation */}
                    <Col>
                        <Form.Control type="number" min={0} step='any' value={(cart[index]?.stocks?.find(s => s.productId === cart[index].productId)?.stock ?? 0) - cart[index]?.netQuantity}
                            style={{ backgroundColor: '#f7e8e8' }}
                            disabled
                        />
                    </Col>

                    {/* Details */}
                    <Col>
                        <Form.Control as="textarea" rows={1}
                            value={cart[index].details}
                            onChange={(e) => handleRowChange(index, e.target.value, 'details')}
                        />
                    </Col>


                    <Col className="d-flex justify-content-end" style={{ flex: 0.2 }}>
                        <BiSolidTrash size={18} onClick={e => handleDeleteRowIndex(index)}
                            style={{ cursor: 'pointer', color: '#e6434f', marginTop: '10px' }} />
                    </Col>

                </Row>




            ))}





            <Row className="mb-3">

                <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                    <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={() => handleAddRow('cart')} />
                    <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e, 'cart')} />

                </Col>

            </Row>

            <Row className="mb-3">

                <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                    <InputGroup style={{ backgroundColor: '#f0f8ff', width: '30%' }}>
                        <Form.Control type="text" placeholder='scan barcode to add ..'
                            value={scannedBarcode} onChange={e => setScannedBarcode(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') { handleBarcodeScan(e); } }} />
                        <InputGroup.Text><IoBarcodeOutline size={25} /></InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>

        </div>

    )
}


export default InvoiceCart;